module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.10-205.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.1-rc.10.md
// module id = 648
// module chunks = 359